import { defineComponent, inject, ref } from 'vue';
import VueScrollTo from 'vue-scrollto';
const { slideDown, slideUp } = window.domSlider;
export default defineComponent({
    setup() {
        const cookies = inject('cookies');
        const details = ref(null);
        let isDetailOpen = false;
        const toggleDetails = () => {
            if (details.value) {
                if (isDetailOpen) {
                    slideUp({
                        element: details.value
                    });
                    isDetailOpen = false;
                }
                else {
                    slideDown({
                        element: details.value,
                        slideSpeed: 0
                    }).then(() => {
                        var _a;
                        VueScrollTo.scrollTo(details.value, 500, {
                            container: (_a = details.value) === null || _a === void 0 ? void 0 : _a.parentElement
                        });
                    });
                    isDetailOpen = true;
                }
            }
        };
        if (!cookies) {
            return;
        }
        return {
            cookies,
            details,
            toggleDetails
        };
    }
});
